const convertTimestampToMonths = (timestamp: number): { months: number; days: number } => {
    const now = new Date().getTime();
    const diffInMilliseconds = timestamp - now;
    const totalDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
    const months = Math.floor(totalDays / 30.44);
    const remainingDays = totalDays - Math.floor(months * 30.44);

    return {
        months: Math.round(months),
        days: Math.round(remainingDays),
    };
};

export const formatDateToGB = (date: string | Date | null | undefined): string => {
    if (!date) return '';

    try {
        const dateObj = new Date(date);
        if (Number.isNaN(dateObj.getTime())) return '';

        return dateObj.toLocaleDateString('en-GB');
    } catch {
        return '';
    }
};

export default convertTimestampToMonths;
